import React, {useContext, useState} from "react";

import {messageBoxContext} from "../../../App";


import {FaCheck} from "react-icons/fa";
import {FaRegCopy} from "react-icons/fa";

import "../../../style/PriorityTableStyles/syncId.css";

export default function SyncId({syncId}: { syncId: string }) {
    const [isCopied, setIsCopied] = useState(false);
    const setMessageBoxProp = useContext(messageBoxContext);

    const handleCopy = () => {
        navigator.clipboard.writeText(syncId).then(() => {
            setIsCopied(true);
            setTimeout(() => setIsCopied(false), 2000); // Reset after 2 seconds
            setMessageBoxProp("");
            setTimeout(() => {
                setMessageBoxProp("syncIdCopied");
            }, 10);
        });
    };


    return (
        <div className="flex items-center syncId-Container" onClick={handleCopy} data-title={syncId}>
            {syncId && (
                <>
                    <span>{`${syncId.substring(0, 3)}...`}</span>
                    <button className="ml-2">
                        {isCopied ? <FaCheck color="green"/> : <FaRegCopy color="black"/>}
                    </button>
                </>
            )}
        </div>
    );
}
